import apis from "./axios.config";
const api = apis.AdMedicalApi;
export default {
  IsVisitable(t) {
    return api.post("PatientVisitor/IsVisitable", t);
  },
  PatientInfo(t) {
    return api.post("PatientVisitor/PatientInfo", t);
  },
  SetPatientVisitorLog(t) {
    return api.post("PatientVisitor/SetPatientVisitorLog", t);
  },
};
